module.exports = __webpack_public_path__ + "media/assets/SetupIcon-89c4ff8a5ac0250e442931a5df9cb0eb.svg";